import script from "./legoDashboard.vue?vue&type=script&lang=js"
export * from "./legoDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/lego-component/components/layout/legoDashboard/legoDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "743b4ab4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('743b4ab4', __exports__)) {
    api.reload('743b4ab4', __exports__)
  }
  
}


export default __exports__